/* eslint-disable */
export default {
  download: 'Downloaden',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
